// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".vertical-display-item-value[data-v-7427b870]:deep(i){color:#fff!important}", ""]);
// Exports
module.exports = exports;
